app.service('subscriptionPaymentToast', function (simpleToastr, message, mopPaymentDataManager) {

	const MESSAGE_CONFIG = {
		PAYMENT: {
			REGISTERED: {
				headerKey: 'subscription-after-payment-message-success-header',
				descriptionKey: 'subscription-after-payment-message-success-description',
				toastType: 'success'
			},
			NOT_REGISTERED: {
				headerKey: 'subscription-after-payment-message-success-without-tokenization-header',
				descriptionKey: 'subscription-after-payment-message-success-without-tokenization-description',
				toastType: 'success'
			},
			ERROR: {
				headerKey: 'subscription-after-payment-message-failure-header',
				descriptionKey: 'subscription-after-payment-message-failure-description',
				toastType: 'error'
			}
		},
		UPSELLING: {
			REGISTERED: {
				headerKey: 'subscription-after-payment-message-success-header',
				descriptionKey: 'subscription-after-payment-message-success-description',
				toastType: 'success'
			},
			NOT_REGISTERED: {
				headerKey: 'subscription-after-payment-message-success-without-tokenization-header',
				descriptionKey: 'subscription-after-payment-message-success-without-tokenization-description',
				toastType: 'success'
			},
			ERROR: {
				headerKey: 'subscription-after-payment-message-failure-header',
				descriptionKey: 'subscription-after-payment-message-failure-description',
				toastType: 'error'
			}
		},
		CHANGE_TOKEN: {
			DEFAULT: {
				headerKey: 'subscription-after-change-token-message-success-header',
				descriptionKey: 'subscription-after-change-token-message-success-description',
				toastType: 'success'
			},
			ERROR: {
				headerKey: 'subscription-after-change-token-message-failure-header',
				descriptionKey: 'subscription-after-change-token-message-failure-description',
				toastType: 'error'
			}
		},
		INSTALMENT: {
			REGISTERED: {
				BLIK: {
					headerKey: 'subscription-after-payment-message-success-blik-header',
					descriptionKey: 'subscription-after-payment-message-success-blik-description',
					toastType: 'success'
				},
				BLIK_RECURRING: {
					headerKey: 'subscription-after-payment-message-success-blik-header',
					descriptionKey: 'subscription-after-payment-message-success-blik-description',
					toastType: 'success'
				},
				E_CARD: {
					headerKey: 'subscription-after-payment-message-success-card-header',
					descriptionKey: 'subscription-after-payment-message-success-card-description',
					toastType: 'success'
				},
				E_CARD_RECURRING: {
					headerKey: 'subscription-after-payment-message-success-card-header',
					descriptionKey: 'subscription-after-payment-message-success-card-description',
					toastType: 'success'
				}
			},
			NOT_REGISTERED: {
				BLIK: {
					headerKey: 'subscription-after-payment-message-success-without-tokenization-header',
					descriptionKey: 'subscription-after-payment-message-success-without-tokenization-description',
					toastType: 'success'
				},
				BLIK_RECURRING: {
					headerKey: 'subscription-after-payment-message-success-without-tokenization-header',
					descriptionKey: 'subscription-after-payment-message-success-without-tokenization-description',
					toastType: 'success'
				},
				DEFAULT: {
					headerKey: 'subscription-after-payment-message-failure-header',
					descriptionKey: 'subscription-after-payment-message-failure-description',
					toastType: 'error'
				}
			},
			ERROR: {
				headerKey: 'subscription-after-payment-message-failure-header',
				descriptionKey: 'subscription-after-payment-message-failure-description',
				toastType: 'error'
			}
		}
	};
	MESSAGE_CONFIG.ACTIVATION = MESSAGE_CONFIG.PAYMENT;

	function show(headerKey, descriptionKey, toastType) {

		Promise.all([
			message.get(headerKey),
			message.get(descriptionKey)
		]).then(([header, description]) => {
			if (toastType === 'success') {
				simpleToastr.success({
					header: header,
					message: description
				});
			} else if (toastType === 'error') {
				simpleToastr.error({
					header: header,
					message: description
				});
			} else {
				throw new Error('Unsupported toast type: ' + toastType);
			}
		});
	}

	function showFlashMessage() {

		const savedPaymentResult = mopPaymentDataManager.load();

		if (!savedPaymentResult) {
			return;
		}

		const processType = savedPaymentResult.processType;
		const tokenizationStatus = savedPaymentResult.tokenizationStatus;
		const paymentMethodId = savedPaymentResult.paymentMethodId;

		const typeConfig = MESSAGE_CONFIG[processType];
		if (!typeConfig) {
			return;
		}

		let config = typeConfig[tokenizationStatus] || typeConfig.DEFAULT;

		if (config && !config.headerKey) {
			config = config[paymentMethodId] || config.DEFAULT;
		}

		if (!config) {
			return;
		}

		show(config.headerKey, config.descriptionKey, config.toastType)
	}

	function showSuccess(headerKey, descriptionKey, toastType = 'success') {

		show(headerKey, descriptionKey, toastType);
	}

	return {
		showFlashMessage,
		showSuccess
	};
});
